import { createFileRoute, redirect } from "@tanstack/react-router";

import { MagicLinkForm } from "@/components/auth/magic-link-form";
import { resolveAuthRedirectTarget } from "@/lib/auth-redirect";
import { noIndexSeo } from "@/lib/seo";

import { redirectSchema } from "./-shared/redirect-schema";

export const Route = createFileRoute("/(landing)/(auth)/magic-link")({
	validateSearch: redirectSchema,
	component: RouteComponent,
	head: ({ match }) =>
		noIndexSeo({
			title: "Magic Link | StudyOS",
			description: "Sign in to your StudyOS account with a magic link.",
			pathname: match.pathname,
		}),
	beforeLoad: async ({ search }) => {
		const _redirectTo = search?.redirect;

		if (_redirectTo) {
			const redirectTo = resolveAuthRedirectTarget(_redirectTo);

			throw redirect({ to: redirectTo });
		}
	},
});

function RouteComponent() {
	const search = Route.useSearch();

	return (
		<div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
			<div className="w-full max-w-sm">
				<MagicLinkForm redirectTo={resolveAuthRedirectTarget(search?.from)} />
			</div>
		</div>
	);
}
